var React = require('react');

function Bolt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 24.19a23.89 23.89 0 0 1-.79 6L180.61 160l-37.9 128H24a24 24 0 0 1-24-24 24.45 24.45 0 0 1 .21-3.2l32-240A24 24 0 0 1 56 0h144a24.09 24.09 0 0 1 24 24.19z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M319.93 184.07a23.93 23.93 0 0 1-3.22 11.93l-176 304a24 24 0 0 1-44.1-17.5l46.1-194.5 37.9-128H296a24 24 0 0 1 23.93 24.07z","className":"fa-primary","key":2})]);
}

Bolt.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = Bolt;

Bolt.default = Bolt;
